var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.has)?_c('span',{staticClass:"block red--text mt-2 caption"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }